module.exports = __webpack_public_path__ + "img/noData.b6e7e46e.png";